import { BasicInput } from '@/view/components/BasicInput'
import { Label } from '@/view/components/ui/label'
import { Textarea } from '@/view/components/ui/textarea'
import { phoneMask } from '@/app/utils/phoneFormater'
import { FormProvider } from 'react-hook-form'
import { Button } from '@/view/components/ui/button'
import { useContactController } from './useContactController'
import { Logo } from '@/view/components/ui/logo'

export function ContactPage() {
  const { cards, errors, methods, onSubmit } = useContactController()
  return (
    <main className="flex flex-col items-center gap-4 p-5">
      <div className="mb-4">
        <Logo />
      </div>
      <h1 className="text-4xl font-bold uppercase">Entre Em contato</h1>
      <div className="mt-4 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {cards.map(({ subtitle, title, value, href }) => (
          <div
            key={title}
            className="flex min-w-[316px] max-w-[380px] cursor-pointer flex-col items-center gap-2 rounded-xl border p-5 hover:bg-gray-50"
            onClick={() => window.open(href, '_blank')}
          >
            <h2 className="font-bold uppercase">{title}</h2>
            <p className="text-center">{subtitle}</p>
            <a className="mt-2 font-bold underline-offset-1 hover:text-black/80 hover:underline">
              {value}
            </a>
          </div>
        ))}
      </div>
      <FormProvider {...methods}>
        <div className="mb-8 mt-16 flex flex-col items-center gap-4">
          <h1 className="text-4xl font-bold uppercase">Ouvidoria</h1>
          <div className="text-center">
            <p>Teve algum problema e ainda não conseguiu resolver?</p>
            <p>Nossa Ouvidoria está aqui para ajudar a solucionar seu caso.</p>
          </div>
        </div>
        <form className="w-full max-w-[1160px]" onSubmit={onSubmit}>
          <div className="flex grow flex-col gap-4">
            <BasicInput
              name="name"
              label="Nome completo"
              labelClass="text-md"
              sizeInput="large"
              placeholder="Digite seu nome"
              error={errors.name?.message}
            />

            <BasicInput
              name="email"
              label="E-mail"
              labelClass="text-md"
              sizeInput="large"
              placeholder="email@example.com"
              error={errors.email?.message}
            />

            <BasicInput
              sizeInput="large"
              name="phone"
              label="WhatsApp"
              labelClass="text-md"
              placeholder="(99) 99999-9999"
              error={errors.phone?.message}
              onInput={phoneMask}
            />

            <BasicInput
              name="title"
              label="Motivo do Contato"
              labelClass="text-md"
              sizeInput="large"
              error={errors.title?.message}
            />

            <div className="w-full">
              <Label htmlFor="message" className="w-full">
                Mensagem
                <Textarea
                  {...methods.register('message')}
                  name="message"
                  placeholder="Digite aqui sua mensagem"
                  className="mt-2 h-40 w-full resize-none"
                />
                {errors.message?.message && (
                  <p className="mt-1 text-sm font-light text-error">
                    {errors.message?.message}
                  </p>
                )}
              </Label>
            </div>

            <Button type="submit" className="text-xl font-bold" size="lg">
              Enviar
            </Button>
          </div>
        </form>
      </FormProvider>
    </main>
  )
}
